import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

const InternalHero = ({ data }) => {
  const [Skin, setSkin] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    async function getSkin() {
      const response = await import(
        `./skins/${theme.components.internalHero.skin}/`
      );
      setSkin(() => response.default);
    }

    getSkin();
  }, [theme]);

  return (
    Skin && (
      <Skin
        background={data?.background}
        backgroundMobile={data?.backgroundMobile}
      />
    )
  );
};

InternalHero.defaultProps = {
  data: {},
};

InternalHero.propTypes = {
  data: PropTypes.shape({
    background: PropTypes.string.isRequired,
    backgroundMobile: PropTypes.string.isRequired,
  }),
};

export default InternalHero;
